<template>

    <div style="height: 100px;">
        <v-sheet :height="height" :width="width" v-if="!noData">
            <v-container fluid fill-height>
                <v-row align="center" justify="center">
                    <v-col cols="12" class="text-center">
                        <v-progress-circular :indeterminate="true"
                                             color="grey"
                                             size="100"
                                             width="10"
                        ></v-progress-circular>
                    </v-col>
                    <v-col cols="12" class="text-center">
                        <div class="grey--text">Just a sec pulling in your data...</div>
                    </v-col>
                </v-row>
            </v-container>
        </v-sheet>

        <v-sheet :height="height" :width="width" color="grey darken-3" v-if="noData" style="border: 1px solid yellow">
            <v-container fluid fill-height>
                <v-row align="center" justify="center">

                    <v-col cols="12" class="text-center">
                        <v-icon :color="chargeIconColor" x-large dark>mdi-battery-charging-50</v-icon>
                        <div class="mt-2">
                            <span class="headline grey--text">Insufficient data</span>
                            <div class="normal grey--text text--darken-1">Please check back soon!</div>
                        </div>
                    </v-col>

                </v-row>
            </v-container>
        </v-sheet>
    </div>
</template>

<script>

export default {

    props: {
        loading: {
            type: Boolean,
            required: true,
            default: true,
        },
        height: {
            type: Number | String,
            required: true
        },
        width: {
            type: Number | String,
            required: true,
        },
        noData: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            timerId: null,
            chargeIconColor: 'grey darken-1',
            colorDirection: 'lighter',
            colorValue: 180,
        }
    },

    methods: {

        startTimer() {
            if (!this.timerId) {
                this.timerId = setInterval(() => {
                    this.calculateColor();
                }, 50);
            }
        },

        endTimer() {
            if (this.timerId) clearInterval(this.timerId);
        },

        calculateColor() {
            if (this.colorDirection === 'lighter') {
                this.colorValue+=5;
            } else {
                this.colorValue-=5;
            }

            if (this.colorValue >= 200) this.colorDirection = 'darken';
            if (this.colorValue <= 100) this.colorDirection = 'lighter';

            this.chargeIconColor = 'rgb(' + this.colorValue + ',' + this.colorValue + ',' + this.colorValue + ')';

        }
    },

    mounted() {
        if (this.noData === true) {
            this.startTimer();
        }
    },

    watch: {
        noData(value) {
            if (value) {
                this.startTimer();
            } else {
                this.endTimer();
            }
        }
    }
}
</script>
